import React, {Component, forwardRef} from 'react';
import utilsService from '../../services/utilsService';

import VIDABOO_CONSTANTS from '../../config/consts';

export const WidgetContext = React.createContext();

const CHAT_TRANSITION_TIME = 3.3 * 1000; // aligned with et-hand-off-transition-anim-close

class WidgetContextProvider extends Component {
  constructor() {
    super();
    this.state = {
      widgetDto: null,
      peerInChat: 'temp',
      chatRoomId: undefined,
      callReqId: null,
      engagerReqId: null,
      privateChatRoomDto: null,
      selectedChatRoomId: null,
      arrivedIndicationReceivedMentorIds: [],
      isPeerClientInfoUpdated: false,
      preChatClientMsgToSend: null,
      chatTransitionAnimationType:
        VIDABOO_CONSTANTS.TRANSITION_ANIMATIONS_TYPES.NO_ANIMATION,
      isOoniInControl: utilsService.getIsInWidget(),
    };
    this.chatTransitionTimeout = null;
  }

  setWidgetDto = (widgetDto) => {
    this.setState({widgetDto});
  };
  setChatRoomId = (chatRoomId) => {
    console.debug(chatRoomId, 'From widgetContext');
    this.setState({chatRoomId});
  };
  setCallReqId = (callReqId) => {
    this.setState({callReqId});
  };
  setEngagerReqId = (engagerReqId) => {
    console.debug(engagerReqId, 'engagerReqId from widgetContext', this);

    this.setState({engagerReqId});
  };
  setPrivateChatRoomDto = (privateChatRoomDto) => {
    this.setState({privateChatRoomDto});
  };
  setSelectedChatRoomId = (selectedChatRoomId) => {
    this.setState({selectedChatRoomId});
  };
  setArrivedIndicationReceivedMentorId = (mentorId) => {
    let arrivedIndicationReceivedMentorIds = [
      ...this.state.arrivedIndicationReceivedMentorIds,
    ];
    arrivedIndicationReceivedMentorIds.push(mentorId);
    this.setState({arrivedIndicationReceivedMentorIds});
  };
  resetArrivedIndicationReceivedMentorIds = () => {
    this.setState({arrivedIndicationReceivedMentorIds: []});
  };
  setIsPeerClientInfoUpdated = (isPeerClientInfoUpdated) => {
    this.setState({isPeerClientInfoUpdated});
  };
  setPreChatClientMsgToSend = (preChatClientMsgToSend) => {
    this.setState({preChatClientMsgToSend});
  };
  startTransitionToMentorChatAnim = (cb) => {
    this.setState(
      {
        chatTransitionAnimationType:
          VIDABOO_CONSTANTS.TRANSITION_ANIMATIONS_TYPES
            .TRANSITION_TO_MENTOR_CHAT,
      },
      () => {
        if (cb) cb();
      },
    );
  };
  startTransitionToTeamChatAnim = (cb) => {
    this.setState(
      {
        chatTransitionAnimationType:
          VIDABOO_CONSTANTS.TRANSITION_ANIMATIONS_TYPES.TRANSITION_TO_TEAM_CHAT,
      },
      () => {
        if (cb) cb();
      },
    );
  };
  hideChatTransitionAnim = () => {
    const {TRANSITION_ANIMATIONS_TYPES} = VIDABOO_CONSTANTS;
    const {chatTransitionAnimationType} = this.state;

    // Prevent duplicate transition requests
    if (
      chatTransitionAnimationType ===
        TRANSITION_ANIMATIONS_TYPES.TRANSITION_TO_MENTOR_CHAT_CLOSE ||
      chatTransitionAnimationType ===
        TRANSITION_ANIMATIONS_TYPES.TRANSITION_TO_TEAM_CHAT_CLOSE ||
      chatTransitionAnimationType === TRANSITION_ANIMATIONS_TYPES.NO_ANIMATION
    ) {
      return;
    }
    const closingAnimationType =
      chatTransitionAnimationType ===
      TRANSITION_ANIMATIONS_TYPES.TRANSITION_TO_MENTOR_CHAT
        ? TRANSITION_ANIMATIONS_TYPES.TRANSITION_TO_MENTOR_CHAT_CLOSE
        : TRANSITION_ANIMATIONS_TYPES.TRANSITION_TO_TEAM_CHAT_CLOSE;
    this.setState({chatTransitionAnimationType: closingAnimationType});
    this.chatTransitionTimeout &&
      window.clearTimeout(this.chatTransitionTimeout);
    this.chatTransitionTimeout = setTimeout(() => {
      this.setState({
        chatTransitionAnimationType: TRANSITION_ANIMATIONS_TYPES.NO_ANIMATION,
      });
    }, CHAT_TRANSITION_TIME);
  };

  render() {
    return (
      <WidgetContext.Provider
        value={{
          isPeerClientInfoUpdated: this.state.isPeerClientInfoUpdated,
          widgetDto: this.state.widgetDto,
          setWidgetDto: this.setWidgetDto,
          peerInChat: this.state.peerInChat,
          chatRoomId: this.state.chatRoomId,
          setChatRoomId: this.setChatRoomId,
          callReqId: this.state.callReqId,
          setCallReqId: this.setCallReqId,
          engagerReqId: this.state.engagerReqId,
          setEngagerReqId: this.setEngagerReqId,
          privateChatRoomDto: this.state.privateChatRoomDto,
          setPrivateChatRoomDto: this.setPrivateChatRoomDto,
          selectedChatRoomId: this.state.selectedChatRoomId,
          setSelectedChatRoomId: this.setSelectedChatRoomId,
          arrivedIndicationReceivedMentorIds:
            this.state.arrivedIndicationReceivedMentorIds,
          setArrivedIndicationReceivedMentorId:
            this.setArrivedIndicationReceivedMentorId,
          resetArrivedIndicationReceivedMentorIds:
            this.resetArrivedIndicationReceivedMentorIds,
          setIsPeerClientInfoUpdated: this.setIsPeerClientInfoUpdated,
          preChatClientMsgToSend: this.state.preChatClientMsgToSend,
          setPreChatClientMsgToSend: this.setPreChatClientMsgToSend,
          startTransitionToMentorChatAnim: this.startTransitionToMentorChatAnim,
          startTransitionToTeamChatAnim: this.startTransitionToTeamChatAnim,
          hideChatTransitionAnim: this.hideChatTransitionAnim,
          chatTransitionAnimationType: this.state.chatTransitionAnimationType,
          isOoniInControl: this.state.isOoniInControl,
        }}>
        {this.props.children}
      </WidgetContext.Provider>
    );
  }
}
export default WidgetContextProvider;

export const withWidgetContext = (Component) =>
  //eslint-disable-next-line react/display-name
  forwardRef((props, ref) => (
    <WidgetContext.Consumer>
      {(context) => <Component widgetContext={context} {...props} ref={ref} />}
    </WidgetContext.Consumer>
  ));
